import { render, staticRenderFns } from "./TrigeminalNeuralgia.vue?vue&type=template&id=7313ef9a&scoped=true"
import script from "./TrigeminalNeuralgia.vue?vue&type=script&lang=js"
export * from "./TrigeminalNeuralgia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7313ef9a",
  null
  
)

export default component.exports